module.exports = __webpack_public_path__ + "static/media/analytics.9c3434ee.jpeg";